export default "__VITE_ASSET__DTt0eWu$__"